import { Modal } from "react-bootstrap";
import withPermission from "../../core/common/autorisations/withPermission";
import {
  Action,
  buildPermission,
  Resource,
} from "../../core/common/autorisations/permissionsMap";

//Typage des props parents
type Props = {
  show: boolean;
  metaData: any;
  onClose: () => void;
};
const AperçuEnveloppeExam = ({ show, metaData, onClose }: Props) => {
  // Fonction pour télécharger le PDF
  // 🔽 Personnalisation du nom du fichier
  const handleDownload = () => {
    const url = metaData?.pdfBlobUrl;
    if (!url) return;

    // Créer un lien temporaire
    const a = document.createElement("a");
    a.href = url;

    // 🔽 Personnalisation du nom du fichier
    const classLabel = metaData?.classLabel || "Classe";
    const periodLabel = metaData?.periodLabel || "Periode";
    const level = metaData?.level || "Periode";
    const annee = metaData?.academicYear || "Annee";

    a.download = `Enveloppe_${level}_${classLabel}_${periodLabel}_${annee}.pdf`;
    a.click();
  };

  return (
    <>
      <Modal show={show} onHide={() => onClose()} size="xl" centered>
        <Modal.Header closeButton>
          <Modal.Title>Apercu des enveloppes d'epreuve</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ height: "80vh" }}>
          <iframe
            src={metaData?.pdfBlobUrl}
            style={{ width: "100%", height: "100%" }}
            title="Aperçu PDF"
          />
        </Modal.Body>
        <Modal.Footer className="gap-2">
          <button
            className="btn btn-primary"
            onClick={handleDownload}
            disabled={!metaData?.pdfBlobUrl}
          >
            Télécharger
          </button>
          <button className="btn btn-danger" onClick={() => onClose()}>
            Fermer
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default withPermission(
  AperçuEnveloppeExam,
  [
    buildPermission(Resource.EDTE, Action.READ),
    buildPermission(Resource.EDTE, Action.CREATE),
    buildPermission(Resource.EDTE, Action.UPDATE),
    buildPermission(Resource.EDTE, Action.DELETE),
  ],
  "masquer",
);
